export default function PHP_uniqid() {
  return (
    <div>
      <h1>PHP_uniqid</h1>
    </div>
  );
}
